module.exports = __webpack_public_path__ + "./docs/img/icon-go.73a6eccf16860168e3a47bda0aa56987.svg";